import React from 'react';

import style from './LeafletMap.scss';

import activeNames from '../../../widgets/utils/activeNames';
import LocationAlt from '../../../legacyCore/icons/LocationAlt';

export default function LeafletMarker({
  isActive,
  number,
  marker,
  markerSize = 'md',
  onMarkerHover = null,
  v2 = false,
  ...props
}) {
  let Container = React.Fragment;
  const containerProps = {};
  if (marker.href) {
    Container = 'a';
    containerProps.href = marker.href;
  }
  const markerClassName = activeNames(!!isActive, 'marker', style);
  const markerSizeClassName = style[`marker--${markerSize || 'md'}`];

  const iconClass = v2 ? 'marker__icon__v2' : 'marker__icon';
  return (
    <Container {...containerProps}>
      <div
        {...props}
        className={`${markerClassName} ${markerSizeClassName}`}
        onMouseEnter={() => onMarkerHover && onMarkerHover(marker)}
        onMouseLeave={() => onMarkerHover && onMarkerHover(undefined)}
      >
        <div className={activeNames(!!isActive, iconClass, style)}>
          <LocationAlt />
        </div>
        <div className={style.marker__number}>{number + 1}</div>
      </div>
    </Container>
  );
}
